import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { SearchInput } from "@/ui/inputs/Input";
import useTableService from "@/components/useTableServerSide";
import Footer from "@/components/Footer";
import { Dimmer } from "@/components/spinner";
import { Mensaje } from "@/components/mensajes2";
import ModalClasificadorMulta from "./modalClasificadorMulta";
import { PrimaryButton } from "@/ui/buttons/Button";
import { formatMoneda } from "@/util/varios";

export default function TablaClasificadorMultas(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const searchTimeoutRef = useRef(null);
  const [selectClasif, setSelectClasif] = useState();
  const [loading, setLoading] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [operacion, setOperacion] = useState(1);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const headCells = [
    {
      id: "1",
      label: "CODIGO",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "3",
      label: "DESCRIPCION",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "4",
      label: "VALOR",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "5",
      label: "TIPO IMPUESTO",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      disableSorting: true,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
    onSortChange: (orderBy, orderDir) =>
      setTableState((prev) => ({ ...prev, orderBy, orderDir, page: 0 })),
  };
  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const buscarRegistros = () => {
    setLoading(true);
    const campos = `idtipomulta, descripcion, valor, tipoimpuesto`;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: `tipomulta`,
      orden: "idtipomulta desc",
    };
    const endpoint = `${op.conexion}/api/comun/seleccionar-registros-paginacion`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };
  const operaciones = (op, item) => {
    setSelectClasif(item);
    setMostrarModal(true);
    setOperacion(op);
  };
  const cerrar = () => {
    props.setTabla();
  };
  useEffect(() => {
    const cleanup = buscarRegistros();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);
  return (
    <div
      className="col-8 m-0 p-2 rounded d-flex flex-column justify-content-center"
      style={{ minHeight: "80vh" }}
    >
      <div className="col-12 m-0 p-2 border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
          <h3 className="fw-bold text-light m-0 text-uppercase">
            Clasificador de Multas
          </h3>
          <button onClick={() => cerrar()} className="btn btn-sm bg-light">
            <i className="fa fa-times"></i>
          </button>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
          <div className="col-4 m-0 p-0 position-relative">
            <SearchInput
              className="search-input pe-4"
              value={searchInput}
              onChange={handleSearch}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              icon="fa-plus m-0"
              onClick={() => operaciones(1, "")}
            />
          </div>
        </div>
        <section className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                records.map((item, index) => (
                  <tr key={index} style={{ padding: "0" }}>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "auto",
                      }}
                    >
                      {item.idtipomulta}
                    </td>

                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion.trim()}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "auto",
                      }}
                    >
                      {formatMoneda(
                        item.valor.toString().replace(".", ","),
                        ",",
                        ".",
                        2,
                      )}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      {item.tipoimpuesto}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "50",
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center gap-2 py-0 my-0">
                        <button
                          className="btn btn-sm btn-info rounded-pill"
                          onClick={() => operaciones(2, item)}
                        >
                          <i className="fas fa-eye"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-warning rounded-pill"
                          onClick={() => operaciones(3, item)}
                        >
                          <i className="fa fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-danger rounded-pill"
                          onClick={() => operaciones(4, item)}
                        >
                          <i className="fa fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </section>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={loading} inverted />
      <Footer />
      <ModalClasificadorMulta
        show={mostrarModal}
        onHidden={() => {
          (setMostrarModal(false), buscarRegistros());
        }}
        operacion={operacion}
        clasificador={selectClasif}
      />
    </div>
  );
}
